export interface IBuyingGuideSelection {
  [ key:string ]:number;
}

export interface IBuyingGuideHistory {
  selections: IBuyingGuideSelection ;
}


export class BuyingGuideModel {

  private hist:IBuyingGuideHistory;
  private code:string;
  private all:boolean = false;

  public init():void {
    this.hist = {
      selections:  {}
    };
  }

  public history(history?:IBuyingGuideHistory):IBuyingGuideHistory {
    if (arguments.length) {
      this.hist = history;
    }
    return this.hist;
  }

  public searchCode(code?:string):string {
    if (arguments.length) {
      this.code = code;
    }
    return this.code;
  }

  public showingAll(all?:boolean):boolean {
    if (arguments.length) {
      this.all = all;
    }
    return this.all;
  }

  public clear():void {
    this.hist = undefined;
    this.code = undefined;
    this.all = false;
  }
}